import * as React from "react";
import { forwardRef } from "react";
const SvgRelationDirect = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 29 12",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M24 12L22.5 10.5L26.5 6L22.5 1.5L24 0L29 5.99995L24 12Z",
	fill: "#878E98"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23 7H3.43323e-05L1.71661e-05 5.00001H23L23 7Z",
	fill: "#878E98"
}));
const ForwardRef = forwardRef(SvgRelationDirect);
export default ForwardRef;
